import WithModalBase from "Components/withModal";
import React, { useCallback, useMemo, useRef, useState } from "react";
import MenuItem from "../menuItem";
export default function WithModal(props) {
    const [show, setShow] = useState(false);
    const shownCompletedRef = useRef(false);
    const wrapperAttr = useMemo(() => ({ height: "auto" }), []);
    const { text, title, body: Body, ...other } = props;
    const handleHide = useCallback((e) => {
        var _a;
        if (shownCompletedRef.current) {
            shownCompletedRef.current = false;
            setShow(false);
        }
        else if ((_a = e === null || e === void 0 ? void 0 : e.component) === null || _a === void 0 ? void 0 : _a.show) {
            e.component.show();
        }
    }, []);
    const handleShow = useCallback(() => {
        shownCompletedRef.current = true;
    }, []);
    const handleClose = useCallback(() => {
        shownCompletedRef.current = false;
        setShow(false);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(MenuItem, { text: text, ...other, onClick: () => {
                setShow(true);
            } }),
        React.createElement(WithModalBase, { show: show, container: document.body, title: title, wrapperAttr: wrapperAttr, width: 400, height: "inherit", resizeEnabled: false, contentClassName: "modal-padding", onHide: handleHide, onShow: handleShow },
            React.createElement(Body, { onClose: handleClose }))));
}
